import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Container_Transportation() {
  return (
    <div className="Transportation_of_building_materials-page">

      <div className="Transportation_of_building_materials-hero">
        <div className="Transportation_of_building_materials-overlay">
          <h1>הובלת מכולות</h1>
        </div>
      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הובלת מכולות
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/18.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי הובלת המכולות של נצר הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הובלת מכולות דורשת תכנון נכון, ציוד מתאים וניסיון
            בעבודה עם מכולות בגדלים ובמשקלים שונים. נצר הובלות ומנופים
            מספקת שירותי הובלת מכולות לקבלנים, חברות, עסקים, אתרי בנייה
            ולקוחות פרטיים, בהתאם לסוג המכולה, למשקל ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/14.jpeg"
                alt="הובלת מכולות"
              />
            </div>

            <div className="text-box">

              <p>
                הובלת מכולות דורשת התאמה בין סוג המכולה, המידות,
                המשקל ותנאי הגישה במקום האיסוף והפריקה. לפני ביצוע
                ההובלה חשוב לבחון את סוג המכולה, משקלה, נקודות האיסוף
                והפריקה והאפשרות להגיע בבטחה לנקודת היעד.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות להובלת מגוון סוגי
                מכולות, לרבות מכולות אחסון, מכולות ציוד, מכולות לאתרי
                בנייה ומכולות מטען, בהתאם לסוג ההובלה ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלת מכולות – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל הובלת מכולה מתחילה בבדיקת פרטי ההובלה. יש להבין מהו
              סוג המכולה, מה המשקל הכולל, מהן מידות המכולה ומהי נקודת
              האיסוף והפריקה.
            </p>

            <p>
              בנוסף יש לבחון את תנאי הדרך ואת הגישה לאתר, לרבות
              רחובות צרים, חניות, שערים, אתרי בנייה, שטחים פרטיים
              ומגבלות אחרות שעלולות להשפיע על ביצוע ההובלה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת מכולות באמצעות משאית
            </h2>

            <p>
              משאית מתאימה מאפשרת להעביר מכולות ממקום אחד לאחר בצורה
              מסודרת. התאמת המשאית נעשית בהתאם לסוג המכולה, למשקל,
              למידות ולתנאי הגישה.
            </p>

            <p>
              במקרים שבהם יש צורך גם בהעמסה, פריקה או מיקום באמצעות
              מנוף, ניתן לשלב פתרון הכולל הובלת מכולה ומנוף בהתאם
              לדרישות העבודה ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת מכולות לאתרי בנייה ולעסקים
            </h2>

            <p>
              באתרי בנייה, מפעלים ועסקים יש לעיתים צורך בהובלת
              מכולות לצורך אחסון, ציוד, פסולת או שימושים שונים.
              הובלה מסודרת מאפשרת להציב את המכולה בנקודת היעד
              בהתאם לתכנון העבודה.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי הובלת מכולות לאתרי
              בנייה, עסקים, מפעלים ולמגוון נקודות ברחבי הארץ,
              בהתאם לצורכי הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הובלת מכולות עם מנוף
            </h2>

            <p>
              במקרים שבהם נדרש למקם את המכולה בנקודה שאינה נגישה
              ישירות למשאית, ניתן להשתמש במנוף לצורך הרמה והצבה
              של המכולה בהתאם לאפשרויות העבודה בשטח.
            </p>

            <p>
              שילוב של הובלה ומנוף יכול לסייע במקרים שבהם נדרשת
              הצבה של מכולה בחצר, באתר בנייה, בשטח פרטי או באזור
              שבו הגישה מורכבת.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הובלת מכולות אחסון ומכולות ציוד
            </h2>

            <p>
              מכולות משמשות למגוון צרכים, כגון אחסון ציוד, שימוש
              באתרי בנייה, מחסנים זמניים ופתרונות אחסון לעסקים.
              לפני ביצוע העבודה יש לבדוק את משקל המכולה, מידותיה
              ואופן ההעמסה והפריקה.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את ההובלה כך שתתאים
              למידות המכולה, למשקלה ולתנאי הגישה באתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להובלת מכולות?
            </h2>

            <p>
              הובלת מכולות דורשת תכנון נכון, התאמת אמצעי ההובלה
              ובדיקה מוקדמת של תנאי השטח. תכנון נכון יכול לסייע
              בביצוע ההובלה בצורה מסודרת ויעילה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההובלה לסוג
              המכולה, למשקל, למידות, לתנאי הדרך ולדרישות הפרויקט.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הובלת מכולות בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלת מכולות
              לאתרי בנייה, עסקים, מפעלים ולקוחות פרטיים. השירות
              ניתן בהתאם לסוג המכולה, לתנאי הגישה ולדרישות העבודה.
            </p>

            <p>
              צריכים הובלת מכולה? צרו איתנו קשר, ספרו לנו מה
              אתם צריכים להוביל והיכן נדרשת ההובלה, ונבחן עבורכם
              את פתרון ההובלה המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Transporting_heavy_equipment"
              className="link-right"
            >
             הובלת ציוד כבד
            </Link>

            <Link
              to="/Transportation_and_lifting_of_glass_in_a_vacuum"
              className="link-left"
            >
הובלה והרמה של זכוכית בוואקום
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
